var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"container"},[_c('el-header',{class:{light: _vm.isLogin}},[_c('navbar',{attrs:{"hide-login":_vm.isLogin}})],1),_c('el-main',{class:{pushed: !_vm.isLogin}},[(!_vm.isLoggedIn)?_c('router-view'):_c('with-sidebar',[_c('router-view')],1)],1),_c('el-footer',{staticStyle:{"height":"inherit"}},[_c('app-footer')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03c0bc03","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 